export default __webpack_public_path__ + "static/media/expert_1.a3152a43.png";